import { setError, setLoader } from '../../../actions/app/ui/ui.actions';
import { GET_VEHICULE, VEHICULE, setVehicule } from '../../../actions/app/vehicule/vehicule.actions';
import { API_ERROR, API_SUCCESS, apiRequest } from '../../../actions/core/api/api.actions';

export const vehiculeMiddleware = () => (next) => (action) => {
    next(action);

    const { payload } = action;

    switch (action.type) {
        case GET_VEHICULE:
            next([
                apiRequest({ body: null, method: 'GET', url: payload.data, entity: VEHICULE }),
                setLoader({ state: true, entity: VEHICULE }),
            ]);
            break;

        case `${VEHICULE} ${API_SUCCESS}`:
            next([
                setVehicule({ data: payload.data }),
                setError({ state: false, entity: VEHICULE }),
                setLoader({ state: false, entity: VEHICULE }),
            ]);
            break;

        case `${VEHICULE} ${API_ERROR}`:
            next([setError({ state: true, entity: VEHICULE }), setLoader({ state: false, entity: VEHICULE })]);
            break;

        default:
            return null;
    }
};
